import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import StatusOtherExpense from './Status'

function IndexOtherexp() {
    return(
        <>
        <TextMediumSM content="Finance" />
        <TextMediumSM content="Other Expenses" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusOtherExpense/>
         </div>
         
         </div>
         </>
    )
}

export default IndexOtherexp
